import { useEffect, useRef } from 'react';
import { notify } from '../../../utils/notification';

/** Attacks left in this character's current Attack action (Extra Attack), or 0. */
export const remainingExtraAttacks = (combatState, characterId) => {
  const ledger = combatState?.turnActionLedger;
  if (ledger?.combatantId !== String(characterId) || ledger.turnSequence !== combatState?.turnSequence) return 0;
  const attack = ledger.attackAction;
  const allowed = Number(attack?.ordinaryAttacksAllowed);
  const spent = Number(attack?.ordinaryAttacksSpent);
  return attack?.id && allowed > 1 && spent > 0 && spent < allowed ? allowed - spent : 0;
};

/**
 * Tell the player when an attack leaves more attacks in the same Attack action (Extra Attack).
 * Only a newly spent attack on this turn notifies; loading or refreshing mid-turn stays quiet.
 */
export default function useExtraAttackNotice({ combatState, characterId, isActiveTurn }) {
  const seen = useRef(undefined);
  const attack = combatState?.turnActionLedger?.attackAction;
  const remaining = isActiveTurn ? remainingExtraAttacks(combatState, characterId) : 0;
  const key = remaining > 0 ? `${attack.id}:${attack.ordinaryAttacksSpent}` : null;
  useEffect(() => {
    const first = seen.current === undefined;
    const changed = key !== seen.current;
    seen.current = key;
    if (first || !changed || !key) return;
    notify(`Extra Attack: you have ${remaining} more attack${remaining === 1 ? '' : 's'} this Attack action.`, 'info');
  }, [key, remaining]);
}
